<template>
    <v-card-title class="page-title pb-0">
        <v-row v-if="title">
				<v-col class="pr-2 py-0 ">
					{{ $t(`text.${title}`) }} {{ info }}
				</v-col>
				<v-col align="right" v-if="help">

					<v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-icon
            v-bind="attrs"
            v-on="on">mdi-help-circle-outline</v-icon>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in help"
            :key="index"
          >
            <v-list-item-title><v-icon>{{ item.icon }}</v-icon> {{ item.text }} </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
				</v-col>
        </v-row>
    </v-card-title>
</template>

<script>
export default {
	name: 'PageTitle',
	props: {
		title: {
			type: String,
			required: false,
		},
		info: {
			type: String,
			default: '',
		},
		help: null,
	},
};
</script>

<style lang="scss" scoped>
.page-title {
    color: #e4af0c;
	line-height: 1.25rem;
}
</style>
